var _rect, _rect2, _rect3, _rect4, _rect5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpansionWidgetStyle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 66,
    viewBox: "0 0 153 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 152,
    height: 65,
    rx: 5.5,
    fill: "#EEF1F2",
    stroke: "#E2E8EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#C6CCCE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 65,
    height: 42,
    rx: 2,
    fill: "#C6CCCE"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 19,
    width: 65,
    height: 42,
    rx: 2,
    fill: "#C6CCCE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 5,
    width: 2,
    height: 56,
    rx: 1,
    fill: "#C6CCCE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.324 47L101.307 45.8398L105.648 41.2695C107.151 39.6699 107.872 38.8086 107.881 37.6309C107.872 36.3213 106.782 35.4775 105.35 35.4688C103.829 35.4775 102.88 36.4355 102.871 37.8594H101.377C101.359 35.6094 103.1 34.0977 105.402 34.0977C107.714 34.0977 109.349 35.6533 109.357 37.6309C109.349 39.0547 108.689 40.1621 106.439 42.4824L103.521 45.4883V45.5938H109.586V47H101.324ZM113.312 44.7148L112.346 43.748L115.387 40.707L112.346 37.7012L113.312 36.7168L116.354 39.7402L119.377 36.7168L120.344 37.7012L117.32 40.707L120.344 43.748L119.377 44.7148L116.354 41.6914L113.312 44.7148ZM127.674 34.2734V47H126.074V35.9258H126.004L122.91 37.9824V36.3828L126.074 34.2734H127.674Z",
    fill: "#3C3E40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpansionWidgetStyle);
export default __webpack_public_path__ + "static/media/icon-expansion-widget-style.07aad8b9b0ac25584d7916603964b608.svg";
export { ForwardRef as ReactComponent };